/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Router from "vue-router";
import store from "@/store/store";

Vue.use(Router);
const pages_login_path = "/pages/login";
const current_app_path = "/";
const router = new Router({
	mode: "history",
	base: process.env.BASE_URL,
	scrollBehavior() {
		return { x: 0, y: 0 };
	},
	routes: [
		{
			// =============================================================================
			// MAIN LAYOUT ROUTES
			// =============================================================================
			path: "",
			component: () => import("./layouts/main/Main.vue"),
			children: [
				// =============================================================================
				// Theme Routes
				// =============================================================================

				// {
				// 	path: "/",
				// 	redirect: "/dashboard/customers"
				// },
				{
					path: "/",
					name: "dashboard",
					// component: () => import("./views/apps/customer/CustomerView.vue"),
					component: () => import("./views/apps/user/UserViewDashboard.vue"),
					meta: {
						authRequired: true,
						rule: "isEditor"
					}
				},
				{
					path: "/to-khai-y-te",
					name: "dashboard-technical",
					component: () => import("./views/apps/user/UserView.vue"),
					meta: {
						authRequired: true,
						rule: "isEditor"
					}
				},
				{
					path: "/nhan-vien-c1",
					name: "dashboard-technical",
					component: () => import("./views/apps/user/UserC1View.vue"),
					meta: {
						authRequired: true,
						rule: "isEditor"
					}
				},
				{
					path: "/nhan-vien-c2",
					name: "dashboard-technical",
					component: () => import("./views/apps/user/UserC2View.vue"),
					meta: {
						authRequired: true,
						rule: "isEditor"
					}
				},
				{
					path: "/nhan-vien-c3",
					name: "dashboard-technical",
					component: () => import("./views/apps/user/UserC3View.vue"),
					meta: {
						authRequired: true,
						rule: "isEditor"
					}
				},
				{
					path: "/nhan-vien-c4",
					name: "dashboard-technical",
					component: () => import("./views/apps/user/UserC4View.vue"),
					meta: {
						authRequired: true,
						rule: "isEditor"
					}
				}
				// {
				// 	path: "/can-ho-tro",
				// 	name: "dashboard-technical",
				// 	component: () => import("./views/apps/user/UserHelpView.vue"),
				// 	meta: {
				// 		authRequired: true,
				// 		rule: "isEditor"
				// 	}
				// }
				// {
				// 	path: "/dashboard/maps",
				// 	name: "dashboard-maps",
				// 	component: () => import("./views/apps/maps/MapView.vue"),
				// 	meta: {
				// 		authRequired: true,
				// 		rule: "isEditor"
				// 	}
				// },
				// {
				// 	path: "/dashboard/tracking",
				// 	name: "dashboard-tracking",
				// 	component: () => import("./views/apps/tracking/TrackingView.vue"),
				// 	meta: {
				// 		authRequired: true,
				// 		rule: "isSpecial"
				// 	}
				// }

				// =============================================================================
				// Pages Routes
				// =============================================================================
				// {
				// 	path: "/pages/profile",
				// 	name: "page-user-settings",
				// 	component: () => import("@/views/pages/user-settings/UserSettings.vue"),
				// 	meta: {
				// 		breadcrumb: [{ title: "Home", url: "/" }, { title: "Pages" }, { title: "User Settings", active: true }],
				// 		pageTitle: "Settings",
				// 		rule: "editor"
				// 	}
				// }
			]
		},
		// =============================================================================
		// FULL PAGE LAYOUTS
		// =============================================================================
		{
			path: "",
			component: () => import("@/layouts/full-page/FullPage.vue"),
			children: [
				// =============================================================================
				// PAGES
				// =============================================================================
				{
					path: "/callback",
					name: "auth-callback",
					component: () => import("@/views/Callback.vue"),
					meta: {
						rule: "editor"
					}
				},
				{
					path: "/pages/login",
					name: "page-login",
					component: () => import("@/views/pages/login/Login.vue"),
					meta: {
						rule: "editor"
					}
				},
				{
					path: "/pages/register",
					name: "page-register",
					component: () => import("@/views/pages/register/Register.vue"),
					meta: {
						rule: "editor"
					}
				},
				{
					path: "/pages/forgot-password",
					name: "page-forgot-password",
					component: () => import("@/views/pages/ForgotPassword.vue"),
					meta: {
						rule: "editor"
					}
				},
				{
					path: "/pages/reset-password",
					name: "page-reset-password",
					component: () => import("@/views/pages/ResetPassword.vue"),
					meta: {
						rule: "editor"
					}
				},
				{
					path: "/pages/lock-screen",
					name: "page-lock-screen",
					component: () => import("@/views/pages/LockScreen.vue"),
					meta: {
						rule: "editor"
					}
				},
				{
					path: "/pages/comingsoon",
					name: "page-coming-soon",
					component: () => import("@/views/pages/ComingSoon.vue"),
					meta: {
						rule: "editor"
					}
				},
				{
					path: "/pages/error-404",
					name: "page-error-404",
					component: () => import("@/views/pages/Error404.vue"),
					meta: {
						rule: "editor"
					}
				},
				{
					path: "/pages/error-500",
					name: "page-error-500",
					component: () => import("@/views/pages/Error500.vue"),
					meta: {
						rule: "editor"
					}
				},
				{
					path: "/pages/not-authorized",
					name: "page-not-authorized",
					component: () => import("@/views/pages/NotAuthorized.vue"),
					meta: {
						rule: "editor"
					}
				},
				{
					path: "/pages/maintenance",
					name: "page-maintenance",
					component: () => import("@/views/pages/Maintenance.vue"),
					meta: {
						rule: "editor"
					}
				}
			]
		},
		// Redirect to 404 page, if no match found
		{
			path: "*",
			redirect: "/pages/error-404"
		}
	]
});

router.afterEach(() => {
	// Remove initial loading
	const appLoading = document.getElementById("loading-bg");
	if (appLoading) {
		appLoading.style.display = "none";
	}
});

router.beforeEach((to, from, next) => {
	if (to.path === pages_login_path) {
		if (store.state.auth.isUserLoggedIn()) {
			return router.push({
				path: current_app_path
			});
		}
	}
	// If auth required, check login. If login fails redirect to login page
	if (to.meta.authRequired) {
		if (!store.state.auth.isUserLoggedIn()) {
			router.push({ path: "/pages/login", query: { to: to.path } });
		}
	}
	return next();
});

export default router;
